// extracted by mini-css-extract-plugin
var _1 = "t2s7";
var _2 = "t2s8";
var _3 = "t2s9";
var _4 = "t2s6";
var _5 = "t2s5";
export { _1 as "close", _2 as "container", _3 as "footer", _4 as "text", _5 as "title" }
